import * as am5 from '@amcharts/amcharts5';
import { Color } from '@amcharts/amcharts5';

import { State } from 'features/Frames/types';
import {
  CUSTOM_WARNING,
  PALETTE_BLUE_400,
  PALETTE_ERROR_MAIN,
  PALETTE_NEUTRAL_LIGHT,
  PALETTE_WARNING_MAIN,
} from 'utils/colours';

export const stateFormatter = (state: State | null | undefined): string => {
  if (state == null) {
    return 'N/A';
  }
  switch (state) {
    case State.OK:
      return `OK`;
    case State.LOW_DELIVERY:
      return `Low Delivery`;
    case State.IN_ERROR:
      return `In Error`;
    case State.MIA:
      return `MIA`;
    default:
      return `Deactivated`;
  }
};

export const stateColour = (state: State | null | undefined): string => {
  if (state == null) {
    return PALETTE_NEUTRAL_LIGHT;
  }
  switch (state) {
    case State.OK:
      return PALETTE_BLUE_400;
    case State.LOW_DELIVERY:
      return CUSTOM_WARNING;
    case State.IN_ERROR:
      return PALETTE_WARNING_MAIN;
    case State.MIA:
      return PALETTE_ERROR_MAIN;
    default:
      return PALETTE_NEUTRAL_LIGHT;
  }
};

export const stateColourString = (state: String): Color => {
  switch (state) {
    case State.OK:
      return am5.color(PALETTE_BLUE_400);
    case State.LOW_DELIVERY:
      return am5.color(CUSTOM_WARNING);
    case State.IN_ERROR:
      return am5.color(PALETTE_WARNING_MAIN);
    case State.MIA:
      return am5.color(PALETTE_ERROR_MAIN);
    default:
      return am5.color(PALETTE_NEUTRAL_LIGHT);
  }
};
